import { createUseStyles } from 'react-jss';
import { useDispatch } from 'react-redux';
import { deleteInArray, errorCatch, GET, Model, POST, QueryDetail, QueryOrder, updateInArray } from 'fennec-ui';
import { CollectionServer } from 'fennec-ui';
import PageLayout from '../../components/PageLayout';
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import confirmKey from '../../components/ConfirmKeyModal';
import Icofont from 'react-icofont';
import MDEditor, { } from "@uiw/react-md-editor";
import ModernUserSelection from '../../components/ModernUserSelection';
import User from '../../../common/User';
var isBetween = require('dayjs/plugin/isBetween')
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(isBetween)
dayjs.locale('ru');


var _ = require('lodash');

const useStyles = createUseStyles({
    item: {
        padding: "5px 10px",
        // display: "flex",
        cursor: "pointer",
        '&:hover': {
            backgroundColor: "#f9f9f9"
        }
    },
})

export default function FederationadministratorPostsVsetipipolzovatelei(props) {
    const classes = useStyles();
    const { auth } = props;

    const filters = () => [
        {
            name: "user.lastname",
            sort: true,
            filter: true,
        },
        {
            name: "user.firstname",
            sort: true,
            filter: true,
        },
        {
            name: "user.patronymic",
            sort: true,
            filter: true,
        },

        {
            name: "user.email",
            sort: true,
            filter: true,
        },
        {
            label: "Телефон",
            name: "user.phone",
            sort: true,
            filter: true,
        },
        {
            name: "user.gender",
            sort: true,
            filter: true,
            display: (o) => o.name,
        },
        {
            label: "Дата создания",
            name: "user.createdAt",
            type: "date",
            sort: true,
            filter: true,
        },
        // {
        //     label: "Тип счета",
        //     name: "akkauntType",
        //     filterType: "group",
        //     queryFilter: [
        //         QueryDetail("model"),
        //         QueryOrder("code", "ASC"),
        //         // QueryParam("w-in-id", "2,9")
        //         QueryParam("w-neq-id", "7")
        //     ],
        //     display: (o) => o.opisanie,
        //     sort: true,
        //     filter: true,
        //     // filtered: [2],
        // },
        // {
        //     label: "Баланс счета",
        //     name: "ostatok",
        //     filterType: "range",
        //     func: ["min", "max"],
        //     sort: true,
        //     filter: true,
        // },
        // {
        //     label: "Номер счета",
        //     name: "nomerAkkaunta",
        //     sort: true,
        //     filter: true,
        // },
        // {
        //     label: <FilterFieldLabel label="Владелец" badge="co" color="#919191" background="rgba(216, 216, 216, 0.2)" />,
        //     name: "accountInfo.vladelets",
        //     // queryComparer:"swsim", // sim, wsim, swsim
        //     sort: true,
        //     filter: true,
        // },
    ];

    const render = (item, idx, { setCollection, setCollectionItem, removeCollectionItem, update }) => {
        return (<div key={item.ID || idx} style={{ width: "100%" }}>
            <div className={classes.item}>
                <User item={item?.user} noborder={true} />

            </div>
        </div>)
    }

    // "/api/vsetipipolzovatelei/createrpostslist"
    // "/api/vsetipipolzovatelei/addcreaterposts/{userID}"
    // "/api/vsetipipolzovatelei/deletecreaterposts/{vtpID}"

    return (
        <PageLayout>
            <div style={{ padding: "5px 10px", backgroundColor: "white", borderRadius: "4px" }}>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <div style={{ paddingBottom: "15px", fontSize: "18px" }}>Создатели постов</div>
                </div>
                <CollectionServer
                    auth={auth}
                    name={"VseTipiPolzovatelei"}
                    // queryDetail={"collection"}
                    source={"/api/vsetipipolzovatelei/createrpostslist"}
                    filters={filters}
                    size={"small"}
                    mode={"list"}
                    // title="Создатели постов"
                    render={render}

                    collectionActions={() => [{
                        auth: auth,
                        action: (values, unlock, close, { collection, setCollection }) => {
                            GET(auth, `/api/vsetipipolzovatelei/addcreaterposts/${values?.polzovatel?.ID}`,
                                ({ data }) => {
                                    setCollection(updateInArray(collection, data, true));
                                    close();
                                }, (err) => errorCatch(err, unlock)
                            );
                        },
                        title: "Создать",
                        modal: {
                            title: "Создание роли пользователя",
                            width: "650px"
                        },
                        form: ModernUserSelection,
                        // form: Model,
                        // meta: [
                        //     {
                        //         label: "Пользователь",
                        //         name: "user",
                        //         type: "object",
                        //         relation: {
                        //             display: (item) => {
                        //                 return item.firstname
                        //             },
                        //             reference: { object: "User", property: "ID" },
                        //             type: "many-one",
                        //         },
                        //         queryFilter: [
                        //             QueryDetail("model"),
                        //             QueryOrder("lastname", "ASC")
                        //         ],
                        //     },
                        // ],
                    }]}
                    modelActions={(item) => {
                        return [
                            // {
                            //     auth: auth,
                            //     action: (values, unlock, close, { collection, setCollection }) => {
                            //         POST(auth, `/api/novosti/update`, { ...values, ID: item?.ID },
                            //             ({ data }) => {
                            //                 setCollection(updateInArray(collection, data, true));
                            //                 close();
                            //             }, (err) => errorCatch(err, unlock)
                            //         );
                            //     },
                            //     title: "Изменить",
                            //     modal: {
                            //         title: "Изменение новости",
                            //         width: "650px"
                            //     },
                            //     form: Model,
                            //     meta: [
                            //         {
                            //             label: "Категория",
                            //             name: "kategoriya",
                            //             type: "object",
                            //             relation: {
                            //                 display: (item) => {
                            //                     return item.nazvanie
                            //                 },
                            //                 reference: { object: "KategoriyaNovostei", property: "ID" },
                            //                 type: "many-one",
                            //             },
                            //             queryFilter: [
                            //                 QueryDetail("model"),
                            //                 QueryOrder("nazvanie", "ASC")
                            //             ],

                            //             dropdownActions: () => [
                            //                 {
                            //                     title: "Создать категорию",
                            //                     form: Model,
                            //                     meta: [
                            //                         {
                            //                             label: "Название",
                            //                             name: "nazvanie",
                            //                             type: "string",
                            //                         },
                            //                         {
                            //                             label: "Описание",
                            //                             name: "opisanie",
                            //                             type: "string",
                            //                         },
                            //                     ],
                            //                     action: (values, unlock, close, { collection, setCollection, apply }) => {
                            //                         POST(auth, '/api/kategoriya-novostei/create', { ...values },
                            //                             ({ data }) => {
                            //                                 setCollection(updateInArray(collection, data));
                            //                                 if (apply) {
                            //                                     apply(data);
                            //                                 }
                            //                                 close();
                            //                             },
                            //                             (err) => errorCatch(err, unlock)
                            //                         );
                            //                     },
                            //                 },
                            //             ]
                            //         },
                            //         {
                            //             label: "Опубликована",
                            //             name: "opublikovana",
                            //             type: "bool",
                            //         },
                            //         {
                            //             label: "Дата новости",
                            //             name: "dataNovosti",
                            //             type: "date",
                            //         },
                            //         {
                            //             label: "Заголовок",
                            //             name: "zagolovok",
                            //             type: "string",
                            //         },
                            //         {
                            //             label: "Новость сокращенная",
                            //             name: "novostSokrashchennaya",
                            //             type: "func",
                            //             render: (auth, item, value, onChange, onAfterChange, isChanged) => {
                            //                 return (<MDEditor
                            //                     data-color-mode="light"
                            //                     value={value} onChange={onChange}
                            //                     preview={"edit"}
                            //                     overflow={false}
                            //                 />)
                            //             }
                            //         },
                            //         {
                            //             label: "Полный текст новости",
                            //             name: "novost",
                            //             type: "func",
                            //             render: (auth, item, value, onChange, onAfterChange, isChanged) => {
                            //                 return (<MDEditor
                            //                     data-color-mode="light"
                            //                     value={value} onChange={onChange}
                            //                     preview={"edit"}
                            //                     overflow={false}
                            //                 />)
                            //             }
                            //         },
                            //         {
                            //             label: "Ссылка на ресурс",
                            //             name: "ssilkaNaResurs",
                            //             type: "string",
                            //         },
                            //     ],
                            // },
                            {
                                auth: auth,
                                title: <span style={{ color: "red" }}>Удалить</span>,
                                action: (values, unlock, close, { collection, setCollection }) => {
                                    confirmKey({
                                        pass: '123',
                                        title: <span><Icofont icon="check-circled" style={{ color: "orange" }} /> Удалить роль пользователя</span>,
                                        icon: undefined,
                                        content: <div>
                                            <div>Вы действительно хотите удалить роль пользователя?</div>
                                            <div style={{ fontSize: "14px", fontWeight: "bold" }}>{item?.zagolovok} </div>
                                        </div>,
                                        okText: 'Удалить',
                                        cancelText: 'Отмена',
                                        onOk() {
                                            return new Promise((resolve, reject) => {
                                                GET(auth, '/api/vsetipipolzovatelei/deletecreaterposts/' + item.ID,
                                                    ({ data }) => {
                                                        setCollection(deleteInArray(collection, item));
                                                        resolve(data);
                                                    }, (err) => errorCatch(err, reject));
                                            }).catch(() => { });
                                        },
                                        onCancel() {
                                        },
                                    })
                                }
                            }
                        ]
                    }}
                />
            </div>
        </PageLayout>

    );
}
